import { nanoid } from "nanoid";
import RepairDiagnosticsSessionDetails from "../../models/Diagnostics/RepairDiagnosticsSessionDetails";
import { useTranslation } from "react-i18next";

const splitArrayInTwo = <T,>(arr: T[]) => {
  // For 10 items: Math.floor(10/2) + 1 = 6, left: 6, right: 4
  // For 11 items: Math.floor(11/2) + 1 = 6, left: 6, right: 5
  // For 12 items: Math.floor(12/2) + 1 = 7, left: 7, right: 5
  const colA = Math.floor(arr.length / 2) + 1;
  return [arr.slice(0, colA), arr.slice(colA)];
};
 
 

const RepairDiagnosticsDetailsCard = ({
  diagnosticsDetails,
  additionalInformation,
}: {
  diagnosticsDetails: RepairDiagnosticsSessionDetails;
  additionalInformation?: string;
}) => {
  const { t } = useTranslation();

  if (
    !diagnosticsDetails ||
    !Array.isArray(diagnosticsDetails.diagnosticQuestions)
  ) {
    return null;
  }

  let detailsArray = [
    { label: t("diagnostics_problem_category"), value: diagnosticsDetails.problemCategory ?? "-" },
    { label: t("diagnostics_problem"), value: diagnosticsDetails.problem ?? "-" }
  ];

  if(diagnosticsDetails?.diagnosticQuestions?.length > 0) {
    detailsArray.push(
      ...diagnosticsDetails.diagnosticQuestions.map((q) => ({
        label: q.title,
        value: q.answer,
      }))
    );
  }

  detailsArray.push(
    { label: t("diagnostics_repair_diagnosis"), value: diagnosticsDetails.repairDescription ?? "-" },
    { label: t("diagnostics_repair_description"), value: additionalInformation ?? "-" },
  );

  const [firstCol, secondCol] = splitArrayInTwo(detailsArray);

  const renderColumn = (column: any[]) =>
    column.map((item) => (
      <div key={nanoid()} className="mb-3">
        <div><strong>{item.label}</strong></div>
        <div>{item.value ?? "-"}</div>
      </div>
    ));

return (
  <>
          <div className="bg-grey border-grey rounded-lg">
            <div className="px-4 py-4 darker-grey">
              <strong>{t("repair_diagnostics_overview")}</strong>
            </div>
          </div>

        <div className="bg-grey px-4 py-4">
          <div className="row gx-4 gy-0">
            <div className="col-12 col-md-6">{renderColumn(firstCol)}</div>
            <div className="col-12 col-md-6">{renderColumn(secondCol)}</div>
          </div>
        </div>
  </>
);
};

export default RepairDiagnosticsDetailsCard;